// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'conjuntos.title': 'Conjuntos',
    'conjuntos.eyebrow': 'Logística',
    'conjuntos.aba.caminhoes': 'Caminhões',
    'conjuntos.aba.maquinas': 'Máquinas',
    'conjuntos.aba.utilitarios': 'Utilitários',
    'conjuntos.aba.caminhoes2Reboques': 'Caminhões 2 Reboques',
  },
  en: {
    'conjuntos.title': 'Sets',
    'conjuntos.eyebrow': 'Logistics',
    'conjuntos.aba.caminhoes': 'Trucks',
    'conjuntos.aba.maquinas': 'Machines',
    'conjuntos.aba.utilitarios': 'Utility vehicles',
    'conjuntos.aba.caminhoes2Reboques': 'Trucks with 2 trailers',
  },
  es: {
    'conjuntos.title': 'Conjuntos',
    'conjuntos.eyebrow': 'Logística',
    'conjuntos.aba.caminhoes': 'Camiones',
    'conjuntos.aba.maquinas': 'Máquinas',
    'conjuntos.aba.utilitarios': 'Utilitarios',
    'conjuntos.aba.caminhoes2Reboques': 'Camiones con 2 remolques',
  },
}
